import { useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';

export const useMaintenanceRedirect = () => {
  const { currentUser } = useAuth();

  useEffect(() => {
    // Verificar modo manutenção no Firebase
    const maintenanceRef = doc(db, 'system', 'maintenance');
    
    const unsubscribe = onSnapshot(maintenanceRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        const maintenanceEnabled = data.enabled === true;
        
        // Redirecionamento automático para usuários não autenticados
        if (maintenanceEnabled && !currentUser && window.location.pathname !== '/manutencao') {
          console.log('🔧 Modo manutenção ativado - redirecionando para página de manutenção');
          window.location.href = '/manutencao';
        }
        
        // Se manutenção foi desativada e usuário está na página de manutenção, redirecionar para home
        if (!maintenanceEnabled && window.location.pathname === '/manutencao') {
          console.log('✅ Modo manutenção desativado - redirecionando para home');
          window.location.href = '/';
        }
      }
    }, (error) => {
      console.error('Erro ao verificar modo manutenção:', error);
    });

    return () => unsubscribe();
  }, [currentUser]);
};
